import React from 'react'
import PropTypes from 'prop-types'
import {
    Stepper,
    Step,
    StepIndicator,
    StepStatus,
    StepTitle,
    StepDescription,
    StepSeparator,
    StepNumber,
    useSteps,
    Flex,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import {useIntl, defineMessages} from 'react-intl'
import {remCalc} from '../../../theme/_utils'

const ProductRegistrationStepper = ({index}) => {
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('ProductRegistrationStepper')

    const messages = defineMessages({
        yourProduct: {
            id: 'productRegistrationStepper.yourProduct',
            defaultMessage: 'Your product',
        },
        yourData: {
            id: 'productRegistrationStepper.yourData',
            defaultMessage: 'Your data',
        },
        purchaseDetails: {
            id: 'productRegistrationStepper.purchaseDetails',
            defaultMessage: 'Purchase details',
        },
        yourProductTitle: {
            id: 'productRegistrationStepper.yourProductTitle',
            defaultMessage: 'Provide details about your product',
        },
        yourDataTitle: {
            id: 'productRegistrationStepper.yourDataTitle',
            defaultMessage: 'Enter your personal information',
        },
        purchaseDetailsTitle: {
            id: 'productRegistrationStepper.purchaseDetailsTitle',
            defaultMessage: 'Fill in your purchase details',
        },
    })

    const steps = [
        {
            title: formatMessage(messages.yourProduct),
            description: formatMessage(messages.yourProductTitle),
        },
        {
            title: formatMessage(messages.yourData),
            description: formatMessage(messages.yourDataTitle),
        },
        {
            title: formatMessage(messages.purchaseDetails),
            description: formatMessage(messages.purchaseDetailsTitle),
        },
    ]

    const {activeStep} = useSteps({
        index: index,
        count: steps.length,
    })

    return (
        <Stepper index={activeStep} {...styles.stepper} _horizontal={{...styles.stepper}}>
            {steps.map((step, index) => (
                <Step key={index} {...styles.step} _horizontal={{...styles.step}}>
                    <Flex {...styles.flexContainer}>
                        <StepIndicator
                            {...styles.stepIndicator}
                            width={{base: remCalc(32), lg: remCalc(40)}}
                            height={{base: remCalc(32), lg: remCalc(40)}}
                            sx={{
                                '&[data-status=complete]': {
                                    backgroundColor:
                                        activeStep > index
                                            ? 'background.alternative'
                                            : 'background.grey',
                                },
                            }}
                        >
                            <StepStatus
                                complete={<StepNumber {...styles.stepNumber} />}
                                incomplete={<StepNumber {...styles.stepNumber} />}
                                active={<StepNumber {...styles.stepNumber} />}
                            />
                        </StepIndicator>

                        <Flex {...styles.flexLabel}>
                            <StepTitle
                                sx={styles.stepTitle}
                                color={activeStep > index ? 'text.default' : 'text.disable'}
                                as="p"
                            >
                                {step.title}
                            </StepTitle>
                            <StepDescription
                                sx={{...styles.stepDescription, fontSize: remCalc(12)}}
                                color={activeStep > index ? 'text.default' : 'text.disable'}
                            >
                                {step.description}
                            </StepDescription>
                        </Flex>
                    </Flex>

                    <StepSeparator
                        {...styles.stepSeparator}
                        _horizontal={{...styles.stepSeparator}}
                        sx={{
                            '&[data-status=complete]': {
                                backgroundColor:
                                    activeStep > index + 1
                                        ? 'background.alternative'
                                        : 'background.grey',
                            },
                        }}
                    />
                </Step>
            ))}
        </Stepper>
    )
}
ProductRegistrationStepper.propTypes = {
    index: PropTypes.number,
}

export default ProductRegistrationStepper
